import { useQuery, UseQueryResult } from "@tanstack/react-query";

import * as config from "@/config";

import { useHermesApiToken } from "./use-hermes-api-token";

export interface InsightsThread {
  group_id: string;
  threads: {
    user_id: string;
    resolved: number;
    total: number;
    unresolved: number;
    deleted: number;
  }[];
}

/**
 * Hook to fetch the Threads Insights data from Hermes.
 */
export function useThreadInsights(
  assessmentId: string,
  workId: string,
  studentIds: string[]
): UseQueryResult<InsightsThread[]> {
  const apiToken = useHermesApiToken({ assessmentId, workId });
  return useQuery(
    [`insights/threads`, studentIds],
    async () => {
      const hermesUrl = `${config.HERMESV2_ENDPOINT}/api/insights/threads`;
      try {
        const response = await fetch(hermesUrl, {
          method: "POST",
          credentials: "include",
          headers: {
            Authorization: `Bearer ${apiToken}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            user_ids: studentIds,
            group_ids: []
          }),
        });

        const data: InsightsThread[] = await response.json();
        return data;
      } catch (e) {
        console.error("failed to fetch Threads from Hermes", e);
        return [];
      }
    },
    {
      cacheTime: 100, // No cache, as the default is 5 minutes.
      // Refetch the data only on refresh: decrease database load.
      refetchInterval: false,
      useErrorBoundary: true,
      enabled: !!apiToken,
    }
  );
}
